import React, { useEffect } from 'react'
import styled from 'styled-components'
import { Form, Input } from 'semantic-ui-react'
import * as R from 'ramda'

import {
  TEMP_ID_PREFIX,
  getAutoId,
  MAX_CHOICES_PER_QUESTION,
} from 'organisms/SurveySettingsV2/constants'
import SortableList from 'components/SortableList'

export const FollowUpChoiceInput = ({ choices, logicIndex, setForm, questionType }) => {
  const MAX_CHOICE = MAX_CHOICES_PER_QUESTION

  useEffect(() => {
    if (choices.length < 2) {
      const newChoices = [
        {
          id: `${TEMP_ID_PREFIX}${getAutoId()}`,
          label: '',
          value: '',
          order: 1,
          is_active: true,
        },
        {
          id: `${TEMP_ID_PREFIX}${getAutoId()}`,
          label: '',
          value: '',
          order: 2,
          is_active: true,
        },
      ]
      setForm(['conditions', logicIndex, questionType, 'choices'], newChoices)
    }
  }, [logicIndex, choices.length, setForm, questionType])

  const activeChoices = choices.filter((choice) => choice.is_active)

  function hasReachedMaxChoices() {
    return activeChoices.length >= MAX_CHOICE
  }

  function handleChoiceInputChange(value, choiceIndex) {
    setForm(['conditions', logicIndex, questionType, 'choices', choiceIndex, 'label'], value)
    setForm(['conditions', logicIndex, questionType, 'choices', choiceIndex, 'value'], value)
  }

  function removeChoice(choiceIndex) {
    const hasChoiceId = choices[choiceIndex].id
    let newChoices = []
    let order = 1

    if (hasChoiceId) {
      newChoices = R.assocPath([choiceIndex, 'is_active'], false, choices)
    } else {
      newChoices = R.remove(choiceIndex, 1, choices)
    }

    newChoices.map((choice) => {
      if (choice.is_active) {
        choice.order = order
        order += 1
      }
    })
    setForm(['conditions', logicIndex, questionType, 'choices'], newChoices)
  }

  function addChoice() {
    if (hasReachedMaxChoices()) {
      return
    }

    const newChoice = {
      id: `${TEMP_ID_PREFIX}${getAutoId()}`,
      label: '',
      value: '',
      order: activeChoices.length + 1,
      is_active: true,
    }

    setForm(['conditions', logicIndex, questionType, 'choices'], [...choices, newChoice])
  }

  function changeChoiceOrder(choices) {
    const newChoices = choices.map((choice, index) => ({
      ...choice,
      order: index + 1,
    }))
    setForm(['conditions', logicIndex, questionType, 'choices'], newChoices)
  }

  return (
    <StyledFormFieldChoice>
      <label className="mt-1">Choices</label>

      <SortableList
        items={choices}
        onChange={changeChoiceOrder}
        renderItem={(choice, index) => {
          if (choice.is_active) {
            return (
              <SortableList.Item id={choice.id}>
                <Choice
                  className="relative flex items-center justify-center w-full"
                  key={choice.id}
                >
                  <Input
                    required
                    maxLength={250}
                    className="flex-1 large"
                    data-testid="follow-up-choice-input"
                    value={choice.label}
                    onChange={(e) => {
                      handleChoiceInputChange(e.target.value, index)
                    }}
                  />
                  <SortableList.DragHandle />

                  <RemoveChoiceButton
                    removeChoice={removeChoice}
                    choiceIndex={index}
                    canRemoveChoice={index > 1}
                  />
                </Choice>
              </SortableList.Item>
            )
          } else {
            return null
          }
        }}
      />

      <LinkWrapper>
        <a onClick={addChoice} className={hasReachedMaxChoices() ? 'disabled' : ''}>
          <i className="icon far fa-plus" />
          Add choice
        </a>
      </LinkWrapper>
    </StyledFormFieldChoice>
  )
}

function RemoveChoiceButton({ removeChoice, canRemoveChoice, choiceIndex }) {
  if (canRemoveChoice) {
    return (
      <Icon
        className="icon fas fa-xmark text-grey link"
        onClick={() => removeChoice(choiceIndex)}
      />
    )
  }

  return null
}

const Choice = styled.div`
  &:not(:first-child) {
    margin-top: 0.5rem;
  }
`

const LinkWrapper = styled.div`
  margin-top: 0.5em;
`

const Icon = styled.i`
  cursor: pointer;
  position: absolute;
  right: -3px;
  top: 50%;
  transform: translate(100%, -50%);
`

const StyledFormFieldChoice = styled(Form.Field)`
  margin-top: 17px !important;
`



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/organisms/QuestionConditionModal/FollowUpChoiceInput.js